import { Component, inject } from '@angular/core';
import { RoadPropertyTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RoadPropertyTypeCreateDto,
  RoadPropertyTypeDto,
  RoadPropertyTypeExcelDownloadDto,
  RoadPropertyTypeUpdateDto,
} from '../proxy/general/dtos/road-property-type';
import { ROADPROPERTYTYPE_CONFIG, ROADPROPERTYTYPE_FIELDS } from './road-property-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-road-property-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RoadPropertyTypeService, ConfirmationService],
  templateUrl: './road-property-type.html',
  styleUrl: './road-property-type.scss',
})
export class RoadPropertyType extends BaseCrudComponent<
  RoadPropertyTypeDto,
  RoadPropertyTypeCreateDto,
  RoadPropertyTypeUpdateDto,
  RoadPropertyTypeExcelDownloadDto
> {
  service = inject(RoadPropertyTypeService);
  config = ROADPROPERTYTYPE_CONFIG;
  fields = ROADPROPERTYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RoadPropertyTypeDto): RoadPropertyTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RoadPropertyType';
  }
}
